// DADOS GERAIS
export const nivelHierarquico = [
  {
    id: 1,
    label: 'Nível C-Level'
  },
  {
    id: 2,
    label: 'Nível C-Level (-1)'
  },
  {
    id: 3,
    label: 'Nível C-Level (-2)'
  },
  {
    id: 4,
    label: 'Nível C-Level (-3)'
  },
  {
    id: 5,
    label: 'Nível C-Level (-4)'
  },
  {
    id: 6,
    label: 'Nível C-Level (-5)'
  },
  {
    id: 7,
    label: 'Nível C-Level (-6)'
  }
];

// FERRAMENTAS
export const optionsDesenvolv = [
  {
    id: 'interno',
    label: 'Interno'
  },
  {
    id: 'externo',
    label: 'Externo'
  }
];

// EVENTOS
export const participacaoOptions = [
  {
    id: 'patrocinou',
    label: 'Patrocinou'
  },
  {
    id: 'fomentou',
    label: 'Fomentou'
  },
  {
    id: 'participou',
    label: 'Participou'
  }
];

// REGEX

export const URL =
  /((https?):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/;

//Headers (csv)
export const tagsRel = {
  headers: [
    { key: 'cnpj', label: 'CNPJ' },
    { key: 'empresa', label: 'Empresa' },
    { key: 'ano', label: 'Ano' },
    {
      key: 'fomentoTalento',
      label:
        'Existem processos e/ou instrumentos na minha empresa para identificação de talentos intraempreededores'
    },
    {
      key: 'intraempreendedor',
      label: 'Empresa incentiva e se relaciona com o intraempreendedorismo'
    },
    { key: 'intraempreLista', label: 'Inciativas de intraempreendedorismo' },
    {
      key: 'garantiaIntraemrpre',
      label:
        'Existe um processo estabelecido na minha empresa para garantir o desenvolvimento do intraemprendedorismo'
    },
    {
      key: 'inovacao',
      label:
        'Empresa fomenta outras iniciativas internas relacionadas à inovação, como programa de melhoria contínua'
    },
    { key: 'inovacaoLista', label: 'Iniciativas de inovação' },
    {
      key: 'departInovacao',
      label:
        'Existe uma área(s)/departamento(s) em minha empresa dedicados a Inovação'
    },
    {
      key: 'nivelHirarquia',
      label:
        'Nível hierárquico desta(s) área(s) na estrutura organizacional da empresa'
    },
    {
      key: 'investimentoInovacao',
      label:
        'Durante o ano de referência, quanto a empresa investiu em inovação (R$)'
    },
    {
      key: 'investimentoPdtech',
      label:
        'Deste investimento total em P&D, quanto foi investido em P&D Tech (R$)'
    },
    {
      key: 'ferramentasInova',
      label: 'Minha empresa não usa ferramentas para gerenciar a inovação'
    },
    {
      key: 'pePocs',
      label: "Empresa realizou POC's com startups no ano de referência"
    },
    { key: 'peNumPocs', label: 'Número de trabalhos desenvolvidos' },
    { key: 'peHubs', label: 'Minha empresa participa de hubs de inovação' },
    {
      key: 'peListaHubs',
      label: 'Hubs de inovação dos quais a empresa participa'
    },
    {
      key: 'peHackathons',
      label:
        'Empresa realizou hackathons/bootcamps externos no ano de referência'
    },
    { key: 'peNumHackathons', label: 'Número de hackathon/bootcamps externos' },
    { key: 'ecoInteracStartups', label: 'Não houve interação com startups' },
    { key: 'observacoes', label: 'Observações' },
    { key: 'createdAt', label: 'Data de Criação' },
    { key: 'updatedAt', label: 'Data de Atualização' }
  ]
};
export const tagsRelFerr = {
  headers: [
    { key: 'cnpj', label: 'CNPJ' },
    { key: 'empresa', label: 'Empresa' },
    { key: 'ano', label: 'Ano' },
    { key: 'ferramenta', label: 'Nome da ferramenta' },
    { key: 'desenvolvimento', label: 'Tipo de desenvolvimento' },
    { key: 'solucaoPlatafor', label: 'Nome da solução ou plataforma' },
    { key: 'createdAt', label: 'Inserido' },
    { key: 'updatedAt', label: 'Atualizado' }
  ]
};
export const tagsRelEco = {
  headers: [
    { key: 'cnpj', label: 'CNPJ' },
    { key: 'empresa', label: 'Empresa' },
    { key: 'ano', label: 'Ano' },
    { key: 'nomeStartup', label: 'Nome da Startup' },
    { key: 'contatoStartup', label: 'Nome para contato na Startup' },
    { key: 'emailStartup', label: 'E-mail de contato na Startup' },
    { key: 'siteStartup', label: 'Website da Startup' },
    { key: 'numTrabFeitos', label: 'Número de trabalhos feitos' },
    { key: 'createdAt', label: 'Inserido' },
    { key: 'updatedAt', label: 'Atualizado' }
  ]
};
export const tagsRelEventos = {
  headers: [
    { key: 'cnpj', label: 'CNPJ' },
    { key: 'empresa', label: 'Empresa' },
    { key: 'ano', label: 'Ano' },
    { key: 'nomeEvento', label: 'Nome do Evento' },
    { key: 'participacao', label: 'Patrocinou, Fomentou ou Participou' },
    { key: 'createdAt', label: 'Inserido' },
    { key: 'updatedAt', label: 'Atualizado' }
  ]
};
export const tagsRelPremia = {
  headers: [
    { key: 'cnpj', label: 'CNPJ' },
    { key: 'empresa', label: 'Empresa' },
    { key: 'ano', label: 'Ano' },
    { key: 'nomePremia', label: 'Nome do Prêmio' },
    { key: 'sitePremia', label: 'Website' },
    { key: 'entidadePremia', label: 'Entidade realizadora' },
    { key: 'createdAt', label: 'Inserido' },
    { key: 'updatedAt', label: 'Atualizado' }
  ]
};
